<template>
    <selector-popup
            ref="popup"
            header="Invite Users to Group"
            :items="items"
    >
        <template slot="footer">
            <button @click="back" type="button" class="btn btn-mm  btn-primary">Cancel</button>
        </template>
    </selector-popup>
</template>

<script>
    import SelectorPopup from "../../../../vue/common_components/SelectorPopup/SelectorPopup";
    import Clipboard from "clipboard";
    import Vue from "vue";

    export default {
        name: "InviteUserOptionsPopup",
        components: {SelectorPopup},
        mixins: [],
        data() {
            return {
                options: [], // 'existing' || 'link' || 'invite',
                groupLink: '',
            };
        },
        computed: {
            accessLink() {
                return window.$site + this.groupLink;
            },
            items() {

                const res = [];
                if (this.options.includes('invite')) {
                    res.push({
                        label: 'Invite<br/>to Register',
                        iconClass: 'fa fa-sign-in',
                        action: 'select',
                        selection: 'invite',
                    });
                }
                if (this.options.includes('existing')) {
                    res.push({
                        label: 'Invite<br/>existing User',
                        iconClass: 'fa fa-user',
                        action: 'select',
                        selection: 'existing',
                    });
                }
                if (this.options.includes('link') && Clipboard.isSupported()) {
                    res.push({
                        label: 'Copy<br/>join link',
                        iconClass: 'fa fa-copy',
                        action: 'action',
                        selection: 'copyLink',
                        attrs: {
                            id: 'clipboard_button',
                            'data-clipboard-text': this.accessLink,
                            // 'data-clipboard-target': '#access_link',
                        }
                    });
                }
                return res;
            }
        },
        methods: {
            copyLink() {

            },
            show(options = [], groupLink = '') {
                this.options = options;
                this.groupLink = groupLink;
                return new Promise((resolve, reject) => {
                    this.reject = reject;
                    this.resolve = resolve;
                    this.$refs.popup.show()
                        .then(item => {
                            if (item.action === 'select') {
                                resolve({
                                    action: 'select',
                                    selection: item.selection,
                                });
                            }
                        }, reason => {
                            reject(reason);
                        });
                });
            },
            back() {
                this.reject('back');
            },
        },
        mounted() {
            this.$nextTick(() => {
                this.$_clipboard = new Clipboard('#clipboard_button');
                this.$_clipboard.on('success', (e) => {
                    Vue.notifications.success('Copied');
                    this.resolve({
                        action: 'select',
                        selection: 'link',
                    });
                });

                this.$_clipboard.on('error', (e) => {
                    Vue.notifications.error('You browser doesn\'t support auto copy.');
                    this.reject('Clipboard copy is not supported');
                });
            });
        },
        beforeDestroy() {
            this.$_clipboard?.destroy();
        }
    };
</script>

<style scoped lang="scss">

</style>